var GenIcon = require('../lib').GenIcon

module.exports = function (props) {
   return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 21 21","fill":"currentColor"},"child":[{"tag":"g","attr":{"fill":"none","fillRule":"evenodd","stroke":"#2a2e3b","strokeLinecap":"round","strokeLinejoin":"round","transform":"translate(5 5)"},"child":[{"tag":"path","attr":{"d":"m.5 10.5 10-10"}},{"tag":"path","attr":{"d":"m10.5 10.5-10-10z"}}]}]})(props);
};
